import React from 'react';

const Instructions = () => {
  return (
    <div className="instructions">
      <h3>How to Play:</h3>
      <ul>
        <li>Tap the screen to push your car forward</li>
                                       <li>Faster tapping = higher TPS (Taps Per Second) = faster car movement</li>
        <li>Reach the client to win!</li>
        <li>Try to get there with the fewest taps!</li>
      </ul>
    </div>
  );
};

export default Instructions;
